import React, { useEffect, useState } from "react";
import { notification } from 'antd';
import { DescriptionText, FlexContainer, H1Text, H2Text, Spinner } from "../../design";
import TransactionModal from "../../components/modal/transaction";
import SuccessModal from "../../components/modal/success";
import { getEventDetailsById, getEventPaymentDetails, eventChargeById, getHealthCheck } from "../../api";
import { PAGES, MESSAGES, SWIREPAY_URL, TabNames, SESSION_TIME, LPG_CUSTOMER } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import SmallScreenFooter from "../../components/footer";
import currencyFormatter from "../../utils/currencyformatter";
import CardPayment from "../../components/cardpayment/CardPayment";
import Support from "../../components/support";
import getMenuTabs from "../../utils/getMenuTabs";
import getUniquePaymentTypes from "../../utils/getUniquePaymentTypes";
import UpiPayment from "../../components/upipayment/UpiPayment";
import AchPayment from "../../components/achpayment/AchPayment";
import InstantPayment from "../../components/instantpayment/InstantPayment";
import GooglePay from "../../components/googlePay/GooglePay";
import BankPayment from "../../components/bankpayment/BankPayment";
import NetBanking from "../../components/netbanking/NetBanking";
import PaymentMethodTabs from "../../components/paymentmethodtabs";
import AlertModal from "../../components/modal/alert";
import EPaymentImg from "../../assets/imgs/e payments.svg";
import OMEGAITRlogo from "../../assets/imgs/OmegaITRlogo.png";
import UPIIMAGE from "../../assets/imgs/upiNotification.svg";

type Props = {
    history: {
        push: Function,
    },
}

const SeatsPay = (props: Props) => {

    const { match: { params: { eventLinkId } }, location: { pathname, search } } = props;
    const [isTransactionModalOpen, setTransactionModalOpen] = useState(false);
    const [isTransactionSuccessModalOpen, setTransactionSuccessModalOpen] = useState(false);
    const [payment, setPayment] = useState(null);
    const [errorMessage, setErrorMessage] = useState();
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [backButtonUrl, setBackButtonUrl] = useState(SWIREPAY_URL);
    const [submitBtnText, setSubmitBtnText] = useState(null);
    const [supportedPaymentTypes, setSupportedPaymentTypes] = useState(null);
    const [paymentTypeOrder, setPaymentTypeOrder] = useState(null);
    const [selectedTab, setSelectedTab] = useState(parseInt(localStorage.getItem(`${eventLinkId}-tap-index`) || 0));
    const [tabName, setTabName] = useState('');
    const [banksList, setBanksList] = useState(null);
    const [isTest, setIsTest] = useState(null);
    const [bankTypes, supportedBankTypes] = useState([null]);
    const [bankImageUrl, setBankImageUrl] = useState(null);
    const [partnerImageUrl, setPartnerImageUrl] = useState(null);
    const [gpaySecretValues, setGpaySecretValues] = useState(null);
    const [gpayError, setGpayError] = useState(null);
    const [processStatus, setProcessStatus] = useState(false);
    const [eventDetails, setEventDetails] = useState();
    const [selectedSeats, setSelectedSeats] = useState([]);
    const selectedData = localStorage.getItem('seatsData');
    const [amountInfo, setAmountInfo] = useState();
    const [selectedEntries, setSelectedEntries] = useState();
    const [nonEventSeat, setNonEventSeat] = useState(false);
    const [upiDownTime, setUpiDownTime] = useState(false);
    const [customerInfo, setCustomerInfo] = useState({});
    const [accountInfo, setAccountInfo] = useState();

    const hostName = (window && window.location && window.location.host);

    let seatsData = [];
    let totalAmount = 0;
    let testObject = {};
    let finalSeatsData = [];

    const defaultAlertConfig = {
        showIcon: false, isOpen: false, hideBtn: true,
        cancel: null, header: null, body: null,
        submitBtnText: null, cancelBtnText: null, showCancelBtn: false,
        showSubmitBtn: false, submit: null, icon: null
    };

    const [alertConfig, setAlertConfig] = useState(defaultAlertConfig);

    useEffect(() => {
        if (search) {
            getEventDataWithSearchValue()
        } else {
            getEventDataWithoutSearchValue();
        }
        localStorage.setItem('checkoutPage', true);
        
    }, [eventLinkId, search]);

    useEffect(() => {
        if (selectedData) {
            seatsData = JSON.parse(selectedData);
            setSelectedSeats(seatsData);
            let seatedFlag = false;
            const tempObject = {};
            for (let i = 0; i < seatsData.length; i += 1) {
                if (seatsData[i].type === 'PRICE_AMOUNT_STOCK_BASED') {
                    setNonEventSeat(true);
                    seatedFlag = true;
                }
                if (seatsData[i].type === 'INPUT_EMAIL') {
                    tempObject.email = seatsData[i].value;
                }
                if (seatsData[i].type === 'INPUT_PHONE') {
                    tempObject.phoneNumber = seatsData[i].value;
                }
                if (seatsData[i].type === 'INPUT_SINGLE_LINE_TEXT') {
                    tempObject.name = seatsData[i].value;
                }
            }
            setCustomerInfo(tempObject);
            if (!seatedFlag) {
                for (let i = 0; i < seatsData.length; i += 1) {
                    testObject.seatPageMetaTicketGid = seatsData[i].selectedTicketType;
                    if (eventDetails) {
                        const seatPageMetaTicket = eventDetails.seatPageMetaTickets.filter((data) => data.gid === seatsData[i].selectedTicketType)
                        // console.log(seatPageMetaTicket[0], 'jjjj')
                        testObject.label = seatPageMetaTicket[0].name;
                        testObject.category = seatPageMetaTicket[0].category;
                    } else {
                        testObject.label = seatsData[i].label;
                        testObject.category = seatsData[i].category.label;
                    }
                    testObject.value = seatsData[i].seatPrice * 100;
                    testObject.seat =seatsData[i].seatId;
                    finalSeatsData.push(testObject);
                    // console.log(finalSeatsData);
                    testObject = {};
                  }
            } else if (seatedFlag) {
                finalSeatsData = seatsData;
            }   

            setSelectedEntries(finalSeatsData);
        }
    }, [selectedData, eventDetails]);

    useEffect(() => {
        if (amountInfo && eventDetails && eventDetails.seatPageMetaTickets[0]) {
            setSubmitBtnText(`PAY ${currencyFormatter((amountInfo && (amountInfo.totalPayable / 100.0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}`)
        }
    }, [eventDetails, amountInfo]);

    useEffect(() => {
        setErrorMessage(null);
    }, [selectedTab]);

    const getPaymentInfo = async (list, data) => {
        setShowSpinner(true);
        try {
            const value = await getEventPaymentDetails(list, data.gid);
            if (value) {
                setAmountInfo(value)
            }

        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
      };

    const getEventDataWithSearchValue = async () => {
        const params = new URLSearchParams(search);
        if (!params.get('ps') || !params.get('secret')) {
            props.history.push(`${pathname}/error`);
            return;
        }
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, search);
            if (value) {
                const { redirectUri } = value;
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                if (!redirectUri) {
                    setTransactionSuccessModalOpen(true);
                }
                setTimeout(function () {
                    localStorage.removeItem("seatsData");
                    props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
                }, timeOut);
            }
        } catch (reason) {
            try {
                const value = await getEventDetailsById(eventLinkId, null);
                if (value) {
                    setEventDetails(value.seatPageMeta)
                    setAccountInfo(value.account);
                    setPayment(value);
                    getPaymentInfo(finalSeatsData, value.seatPageMeta);
                }
            } catch (e) {
                props.history.push(`${pathname}/error`);
            }
        } finally {
            setShowSpinner(false);
        }
    };

    const error = reason => {
        setErrorMessage(null);
        const { data: { message, messageCode }, status } = reason;
        if (MESSAGES.PAYMENT_LINK.EXPIRED === message) {
            props.history.push(`${pathname}/expired`)
        } else {
            if (messageCode === 5102) {
                props.history.push(`${pathname}/error`);
                return;
            }
            setErrorMessage(message);
            if (status === 500) {
                setErrorMessage(MESSAGES.PAYMENT_LINK.ERROR);
            }
            resetAlertConfig();
            setTransactionModalOpen(false);
            const errorEl = document.getElementById("error");
            if (null !== errorEl) { errorEl.scrollIntoView(); }
        }
    };

    const getEventDataWithoutSearchValue = async () => {
        setShowSpinner(true);
        try {
            const value = await getEventDetailsById(eventLinkId, null);
            setPayment(value);
            // if (value.account.integratedMerchant && LPG_CUSTOMER.includes(atob(value.account.integratedMerchant))) {
            //     const val = await getHealthCheck();
            //     if (val && val.status !== 'ACTIVE') {
            //         setUpiDownTime(true);
            //         notification.open({
            //             message: '',
            //             description: <img src={UPIIMAGE} alt="" />,
            //           });
            //     }
            //   }
            if (value && value.seatPageMeta) {
                setEventDetails(value.seatPageMeta);
                setAccountInfo(value.account);
            }
            getPaymentInfo(finalSeatsData, value.seatPageMeta);
        } catch (e) {
            props.history.push(`${pathname}/error`);
        } finally {
            setShowSpinner(false)
        }
    };

    const getCustomerGidFromPayment = () => {
        return payment && payment.customer && payment.customer.gid;
    };

    const chargeByUpi = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByAch = async (data) => {
        const { customer, paymentMethod, notify } = data;
        await chargeById({ customer, paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const getByLabelText = (type) => {
        if (type === 'INPUT_ALPHA_NUMERIC') {
          return 'Alpha Numeric';
        } if (type === 'INPUT_NUMBER') {
          return 'Number';
        } if (type === 'INPUT_SINGLE_LINE_TEXT') {
          return 'Single Line Text';
        }
        return null;
      };

    const chargeByCard = async (data) => {
        const { customer, paymentMethod, promoter } = data;
        if (!nonEventSeat) {
            const meta = eventDetails.seatPageMetaTickets;
            const categ = meta.filter((item) => item.type !== 'TICKET');
            for (let i = 0; i < categ.length; i += 1) {
                const tempObj = {};
                tempObj.seatPageMetaTicketGid = categ[i].gid;
                tempObj.type = categ[i].type;
                tempObj.value = data[categ[i].type];
                selectedEntries.push(tempObj);
            }
        }
        
        const payload = {
            seatPageMetaGid: eventDetails.gid,
            customerDetails: customer,
            paymentMethodDetails: paymentMethod,
            seatPageTicketEntries: selectedEntries,
            acceptPromotion: promoter === undefined ? true : promoter,
            paymentMethodType: [
                'CARD'
            ],
        };
        await chargeById(payload);
    };

    const chargeByBank = async (data) => {
        const { fundingSourceId } = data;
        const paymentMethod = {
            type: "ACH",
            bank: {
                referenceId: fundingSourceId,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByNetBanking = async (data) => {
        const { gid, notify } = data;
        const paymentMethod = {
            type: "NET_BANKING",
            netbanking: {
                swirepayBankGid: gid,
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeByInstantPay = async (data) => {
        const { walletAlias, notify } = data;
        const paymentMethod = {
            type: "INSTANT_PAYMENT",
            instantPayment: {
                alias: walletAlias,
                type: "ALIAS",
            },
        };
        await chargeById({ paymentMethod: paymentMethod, shouldWhatsAppNotify: notify, customerGid: getCustomerGidFromPayment(payment) });
    };

    const chargeById = async (data) => {
        setTransactionModalOpen(true);
        try {
            const value = await eventChargeById(eventLinkId, data);
            if (value) {
                const { nextActionUrl, redirectUri, paymentStatus } = value;
                if (paymentStatus && paymentStatus === 'PROCESSING') {
                    setProcessStatus(true);
                }
                
                const timeOut = redirectUri ? SESSION_TIME.REDIRECT_URL : SESSION_TIME.NO_REDIRECT_URL;
                setTransactionModalOpen(false);
                setTransactionSuccessModalOpen(true);
                localStorage.removeItem("seatsData");
                if (redirectUri) {
                    setTimeout(function () {
                        window.location = redirectUri;
                        return;
                    }, 1000);
                } else {
                    setTimeout(function () {
                        props.history.push(`${PAGES.SEATSPAGE_PAY}/${eventLinkId}`);
                    }, 1000);
                }
                
            }
        } catch (reason) {
            error(reason);
            return reason;
        }
    };

    const resetAlertConfig = () => {
        setAlertConfig(defaultAlertConfig)
    };

    const chargeByGooglePay = async (data) => {
        const paymentMethod = {
            type: "WALLET",
            googlePayUS: {
                apiVersionMinor: data.apiVersionMinor,
                apiVersion: data.apiVersion,
                paymentMethodDescription: data.paymentMethodData.description,
                paymentMethodTokenizationDataType: data.paymentMethodData.tokenizationData.type,
                paymentMethodTokenizationDataToken: data.paymentMethodData.tokenizationData.token,
                paymentMethodType: data.paymentMethodData.type,
                paymentMethodInfo: data.paymentMethodData.info
            },
        };
        await chargeById({ paymentMethod: paymentMethod, customerGid: getCustomerGidFromPayment(payment) });
    };

    const uniquePaymentTypes =paymentTypeOrder ? paymentTypeOrder.map((res) => res ? res.category : null) : supportedPaymentTypes ? getUniquePaymentTypes(supportedPaymentTypes) : '';
    const tabPanels = uniquePaymentTypes ? uniquePaymentTypes.reduce(function (panel, name) {
        let children;
        if (name === TabNames.ACH_LEGACY) {
            children = <AchPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByAch}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                showWhatsAppNotify={false}
                buttonText={submitBtnText}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
                isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
            />
        } else if (name === TabNames.CARD) {
            children = <CardPayment
            errorMsg={errorMessage}
            errorHeader={null}
            hideCustomer={false}
            customerReadOnly={false}
            submit={chargeByCard}
            preFillCustomer={eventDetails && eventDetails.seatEventId ? eventDetails : customerInfo}
            headerText={"Pay With Card"}
            buttonText={submitBtnText}
            customerValidation={true}
            alpha2={eventDetails && eventDetails.seatPageMetaTickets[0].currency.countryAlpha2}
            tax={amountInfo && amountInfo.tax }
            totalPayable={amountInfo && amountInfo.totalPayable }
            discount={amountInfo && amountInfo.discountedAmount}
            subTotal={amountInfo && amountInfo.subTotal}
            serviceFee={amountInfo && amountInfo.serviceFee}
            amount={amountInfo && amountInfo.net}
            serviceFeeRate={amountInfo && amountInfo.serviceFee }
            serviceFeeRateVal={amountInfo && amountInfo.serviceFee}
            serviceFeeVal={amountInfo && amountInfo.serviceFee }
            showMeta={!nonEventSeat}
            metaInfo={eventDetails && eventDetails}
            isZipCodeRequired={true}
            requiredPhone={true}
            showPromoter={(accountInfo && accountInfo.accountPromoter && accountInfo.accountPromoter.promoterName)}
            isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
        />
        } else if (name === TabNames.UPI) {
            children = <UpiPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByUpi}
                preFillCustomer={payment}
                headerText={"Pay With UPI"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                showMobileViewUpi={true}
                hideQr={false}
                showWhatsAppNotify={false}
                getPaymentById={null}
                supportedPaymentTypes={payment && payment.account && payment.account.supportedPaymentTypes}
                upiUrl={null}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.ACH) {
            children = <BankPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerDisabled={false}
                submit={chargeByBank}
                preFillCustomer={payment}
                headerText={"Pay With Bank Transfer"}
                buttonText={submitBtnText}
                showWhatsAppNotify={false}
                eventLinkId={eventLinkId}
                iavUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                requiredPhone={true}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
                publicKey={payment && payment.account && payment.account.usPublicKey}
            />
        } else if (name === TabNames.NET_BANKING) {
            children = <NetBanking
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByNetBanking}
                preFillCustomer={payment}
                showWhatsAppNotify={false}
                headerText={"PAY WITH NET BANKING"}
                cancelButtonText={"Decline"}
                buttonText={submitBtnText}
                customerValidation={true}
                banksList={banksList}
                bankTypes={bankTypes}
                isTest={isTest}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else if (name === TabNames.GOOGLE_PAY_US) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.WALLET) {
            children = <GooglePay
                headerText={"PAY WITH GOOGLE PAY"}
                payment={payment}
                chargeByGooglePay={chargeByGooglePay}
                gpaySecretValues={gpaySecretValues}
                gpayError={gpayError}
                errorMsg={errorMessage}
                errorHeader={null}
            />
        } else if (name === TabNames.INSTANT_PAYMENT) {
            children = <InstantPayment
                showCancelBtn={payment && payment.canDecline}
                cancel={null}
                errorMsg={errorMessage}
                errorHeader={null}
                customerReadOnly={false}
                submit={chargeByInstantPay}
                preFillCustomer={payment}
                customerDisabled={true}
                headerText={null}
                buttonText={submitBtnText}
                hideQr={false}
                getPaymentById={null}
                showWhatsAppNotify={false}
                upiUrl={null}
                customerValidation={true}
                cancelButtonText={"Decline"}
                alpha2={payment && payment.currency && payment.currency.countryAlpha2}
            />
        } else {
            children = <DescriptionText>Processing payment. Please wait...</DescriptionText>
        }
        panel.push({ children });
        return panel;
    }, []) : [
        {
            children: <CardPayment
            errorMsg={errorMessage}
            errorHeader={null}
            hideCustomer={false}
            customerReadOnly={false}
            submit={chargeByCard}
            preFillCustomer={eventDetails && eventDetails.seatEventId ? eventDetails : customerInfo}
            headerText={"Pay With Card"}
            buttonText={submitBtnText}
            customerValidation={true}
            alpha2={eventDetails && eventDetails.seatPageMetaTickets[0].currency.countryAlpha2}
            tax={amountInfo && amountInfo.tax}
            totalPayable={amountInfo && amountInfo.totalPayable}
            discount={amountInfo && amountInfo.discountedAmoun}
            subTotal={amountInfo && amountInfo.subTotal}
            serviceFee={amountInfo && amountInfo.serviceFee}
            amount={amountInfo && amountInfo.net }
            serviceFeeRate={amountInfo && amountInfo.serviceFee }
            serviceFeeRateVal={amountInfo && amountInfo.serviceFee}
            serviceFeeVal={amountInfo && amountInfo.serviceFee}
            showMeta={!nonEventSeat}
            metaInfo={eventDetails && eventDetails}
            isZipCodeRequired={true}
            showPromoter={(accountInfo && accountInfo.accountPromoter && accountInfo.accountPromoter.promoterName)}
            requiredPhone={true}
            isBillingAdressRequired={(payment && payment.account && payment.account.collectBillingAddress)}
        />
        }
    ];
    useEffect(() => {
        setTabName(uniquePaymentTypes && uniquePaymentTypes[selectedTab]);
    }, [selectedTab, uniquePaymentTypes]);
    const agregatorName = payment && payment.account && payment.account.aggregatorName;
    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        {
                            (payment && payment.account && payment.account.largeLogo) && (
                                <img src={payment.account.largeLogo} style={{ width: "125px" }} alt="" />
                            )
                        }
                        <H1Text>
                            Payment Checkout
                        </H1Text>
                        <H2Text>
                            Payment For { payment && payment.account && <DescriptionText>{payment.account.name}</DescriptionText> }
                        </H2Text>
                        {
                            selectedSeats && selectedSeats.length !== 0 && (
                                <>
                                    {
                                        selectedSeats.map((item) => (
                                                item.numSelected ?
                                                  <DescriptionText>{item.seatId} - {item.numSelected}</DescriptionText>
                                                :<DescriptionText>{item.seatId}</DescriptionText>
                                        ))
                                    }
                                </>
                            )
                        }
                        <H2Text>
                            Amount Payable
                        </H2Text>
                        <DescriptionText fontSize="24px">
                            {amountInfo ? `${currencyFormatter((amountInfo && (amountInfo.totalPayable / 100.0)), eventDetails && eventDetails.seatPageMetaTickets[0].currency.name)}` : null}
                        </DescriptionText>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={payment && payment.support && payment.support.email}
                            phone={payment && payment.support && payment.support.phone}
                            partnerImageUrl={partnerImageUrl}
                            bankImageUrl={bankImageUrl}
                            whiteLabel={payment && payment.account && payment.account.whiteLabel}
                        />
                        {agregatorName === 'EPAYMENTS' ?
                            <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                <a href="https://www.swirepay.com" target="_blank" >
                                    <img src={EPaymentImg} alt="" />
                                </a>
                            </div>
                            :
                            agregatorName === 'OMEGAITR' ?
                                <div style={{ position: "sticky", marginLeft: "75%", bottom: "9%" }} >
                                    <a href="https://www.swirepay.com" target="_blank" >
                                        <img src={OMEGAITRlogo} alt="" />
                                    </a>
                                </div>
                                :
                                ''
                        }
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header account={payment ? payment.account : null} payment={amountInfo} eventDetails={eventDetails} selectedSeats={selectedSeats} bankImageUrl={bankImageUrl} />
                <PaymentMethodTabs
                    name={eventLinkId}
                    paymentTypes={(payment && payment.account && payment.account.currency && payment.account.currency.countryAlpha2)}
                    tabs={getMenuTabs(uniquePaymentTypes)}
                    tabPanels={tabPanels}
                    defaultSelectedTab={selectedTab || 0}
                    onSelect={data => setSelectedTab(data)}
                    tabName={tabName}
                    upiDown={upiDownTime}
                />
                <SmallScreenFooter
                    partnerImageUrl={partnerImageUrl}
                    bankImageUrl={bankImageUrl}
                    whiteLabel={payment && payment.account && payment.account.whiteLabel}
                />
                <TransactionModal body={null} header={null} isOpen={isTransactionModalOpen} />
                <SuccessModal isOpen={isTransactionSuccessModalOpen} processing={processStatus} />
                <AlertModal
                    showIcon={alertConfig.showIcon}
                    isOpen={alertConfig.isOpen}
                    hideBtn={alertConfig.hideBtn}
                    cancel={alertConfig.cancel}
                    header={alertConfig.header}
                    body={alertConfig.body}
                    submitBtnText={alertConfig.submitBtnText}
                    cancelBtnText={alertConfig.cancelBtnText}
                    showCancelBtn={alertConfig.showCancelBtn}
                    showSubmitBtn={alertConfig.showSubmitBtn} submit={alertConfig.submit} icon={alertConfig.icon} />
                <Spinner isOpen={isShowSpinner} />
            </>
        } />
    )
};

export default SeatsPay;
